import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import {
  EmployeeTourEditInput,
  EmployeeTourEditInputStoreService
} from 'src/app/services/employee-tour-edit/employee-tour-edit-input-store.service';
import {
  ModalService,
  ObservableHandlerPair
} from 'src/app/services/modal.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { EmployeeTourEditModalComponent } from '../tour/tour-page/employee-tour-edit-modal/employee-tour-edit-modal.component';

@Component({
  selector: 'immo-redirect-landing-page',
  templateUrl: './immo-redirect-landing-page.component.html',
  styleUrls: ['./immo-redirect-landing-page.component.scss']
})
export class ImmoRedirectLandingPageComponent extends SubscriptionBasedComponent
  implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private employeeTourEditInputStoreService: EmployeeTourEditInputStoreService,
    private modalService: ModalService,
    private router: Router
  ) {
    super();
  }

  ngOnInit(): void {
    this.addSubscription(this.route.params, (params: Params) => {
      this.handleParams(params);
    });
  }

  private handleParams(params: Params): void {
    if (params == null || params['subProjectId'] == null) {
      this.router.navigate(['immo']);
    }

    const subProjectId = Number(params['subProjectId']);
    if (!GeneralHelper.isNumeric(subProjectId)) {
      this.router.navigate(['immo']);
    }

    const employeeTourEditInput: EmployeeTourEditInput = this.employeeTourEditInputStoreService.consumeEmployeeTourEditInput(
      subProjectId
    );
    if (employeeTourEditInput == null) {
      this.router.navigate(['immo']);
    }

    this.handleOpenModal(employeeTourEditInput);
  }

  private handleOpenModal(employeeTourEditInput: EmployeeTourEditInput): void {
    this.modalService.openComponentInModal(
      EmployeeTourEditModalComponent,
      [
        { key: 'placer', value: employeeTourEditInput.placer },
        { key: 'tourId', value: employeeTourEditInput.tourId },
        { key: 'tourDate', value: employeeTourEditInput.tourDate },
        { key: 'placerOptions', value: employeeTourEditInput.placerOptions }
      ],
      new ObservableHandlerPair(
        modalRef => modalRef.afterClosed(),
        (intendOpenSubProject: boolean) => {
          if (!intendOpenSubProject) {
            this.router.navigate(['immo']);
          }
        }
      ),
      { minWidth: '97vw', minHeight: '750px' },
      false
    );
  }
}
